module.exports = __webpack_public_path__ + "img/ntw3-womens-mono.13569af0.jpg";